import React from "react";
import { Outlet,useOutletContext } from "react-router-dom";

const PrivateRoutes = () => {
  const OutletCtx = useOutletContext();
  return <Outlet context={OutletCtx}/>
};

export default PrivateRoutes;
